<div class="product-card" *ngIf="product; else fallbackTpl">
  <!-- Header: image + info -->
  <div class="product-card__header">
    <div class="product-card__img-wrap">
      <img *ngIf="product.imageUrl && !imageError"
           [src]="product.imageUrl"
           [alt]="product.brand + ' ' + product.model"
           class="product-card__img"
           (error)="onImageError()" />
      <div *ngIf="!product.imageUrl || imageError" class="product-card__img-placeholder">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">
          <circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/>
        </svg>
      </div>
    </div>
    <div class="product-card__info">
      <span class="product-card__brand">{{ product.brand }}</span>
      <span class="product-card__model">{{ product.model }}</span>
      <span class="product-card__dims">{{ product.dimensions }}</span>
    </div>
  </div>

  <!-- Specs badges -->
  <div class="product-card__specs" *ngIf="product.efficiency || product.wetGrip || product.season">
    <span class="product-card__badge" *ngIf="product.efficiency" [title]="'chatAi.productCard.efficiency' | translate">
      ⚡ {{ product.efficiency }}
    </span>
    <span class="product-card__badge" *ngIf="product.wetGrip" [title]="'chatAi.productCard.wetGrip' | translate">
      💧 {{ product.wetGrip }}
    </span>
    <span class="product-card__badge" *ngIf="product.noiseLevel" [title]="'chatAi.productCard.noise' | translate">
      🔊 {{ product.noiseLevel }}dB
    </span>
    <span class="product-card__badge" *ngIf="product.season" [title]="'chatAi.productCard.season' | translate">
      {{ product.season === 'winter' ? '❄️' : product.season === 'summer' ? '☀️' : '🔄' }}
      {{ product.season }}
    </span>
  </div>

  <!-- Provider + delivery -->
  <div class="product-card__provider" *ngIf="product.providerName">
    <span>{{ 'chatAi.productCard.provider' | translate }}: <strong>{{ product.providerName }}</strong></span>
    <span *ngIf="product.deliveryDays">· {{ 'chatAi.productCard.delivery' | translate }}: {{ product.deliveryDays }} {{ 'chatAi.productCard.days' | translate }}</span>
  </div>

  <!-- Price + quantity + total -->
  <div class="product-card__purchase">
    <div class="product-card__price">
      <span class="product-card__price-unit">{{ product.pricePerUnit | number:'1.2-2' }} {{ product.currency }}/{{ 'chatAi.productCard.unit' | translate }}</span>
    </div>

    <div class="product-card__qty">
      <button type="button" class="product-card__qty-btn" (click)="decrement()" [disabled]="quantity <= 1">−</button>
      <span class="product-card__qty-value">{{ quantity }}</span>
      <button type="button" class="product-card__qty-btn" (click)="increment()" [disabled]="quantity >= maxQuantity">+</button>
    </div>

    <div class="product-card__total">
      <span class="product-card__total-label">{{ 'chatAi.productCard.total' | translate }}</span>
      <span class="product-card__total-value">{{ totalPrice }} {{ product.currency }}</span>
    </div>
  </div>

  <!-- Stock info -->
  <div class="product-card__stock" [class.low]="product.stockAvailable <= 4">
    {{ product.stockAvailable > 0 ? (product.stockAvailable + ' ' + ('chatAi.productCard.unitsAvailable' | translate)) : ('chatAi.productCard.noStock' | translate) }}
  </div>

  <!-- Buy button -->
  <button type="button"
          class="product-card__buy"
          [disabled]="product.stockAvailable <= 0"
          (click)="onBuy()">
    {{ 'chatAi.productCard.buy' | translate }} {{ quantity }} {{ 'chatAi.productCard.units' | translate }} — {{ totalPrice }} {{ product.currency }}
  </button>
</div>

<ng-template #fallbackTpl>
  <pre class="product-card__raw" *ngIf="fallbackRaw">{{ fallbackRaw }}</pre>
</ng-template>
